import React from 'react';
import '../less/atb-new.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../auxiliary-components/shared/HeroBlock';
import CardOrderModal from '../../../../auxiliary-components/CardOrderModal';
import { atbCardTerms } from '../../../../services/urls/urls';
import Tariffs from '../../../../auxiliary-components/shared/TariffsBlock';
import AdditionalProduct from '../../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsNew from '../../../../auxiliary-components/shared/QuestionsNew';
import QuestionsAdminNew from '../../../../auxiliary-components/shared/QuestionsAdminNew';
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew";
import Tabs from '../../../../auxiliary-components/shared/Tabs';
import TextAboveFooterNew from "../../../../auxiliary-components/shared/TextAboveFooterNew";
import FAQStorybook from '@abank/abank-faq';
import HowToBlockNew from '../../../../auxiliary-components/shared/HowToBlockNew';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import how_to_block_img_4 from '../img/how_to_block_img_4.png';
import CalculatorNew from '../../../../auxiliary-components/CalculatorNew';
import { Preloader } from 'MWComponents';
import { canUseDOM } from '../../../../helpers/canUseDOM';
import additionalCards from '../enums/additional_cards_data.json';
import howToBlockItemsData from '../enums/how_to_block_items.json';
import tariffs_data from '../enums/tariffs_data.json';
import hero_data from '../enums/hero_data.json';
import AdvantagesAdmin from '../../../../auxiliary-components/shared/AdvantagesBlockAdmin';
import loyaltyProgramDataConfig from '../enums/loyalty_program_data.json';
import loyalty_program_img_1 from '../img/loyalty_program_img_1.png';
import loyalty_program_img_2 from '../img/loyalty_program_img_2.png';
import { filterByEnvironment } from '../../../../helpers/utils/environmentFilter';
import { howToGetCardItems } from '../../enums/howToGetCardData';

const imagesMap = {
  how_to_block_img_1,
  how_to_block_img_2,
  how_to_block_img_3,
  how_to_block_img_4,
  loyalty_program_img_1,
  loyalty_program_img_2
};

export default function template() {
    const page = 'atb-card-new';
    const model = this.getModel();

    const tabs = [{tab: 'tariffs', title: 'ATB_CARD_NEW_TABS_INFO_TITLE_01'},
          {tab: 'how-to-get-card', title: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TAB_TITLE'},
          {tab: 'loyalty-program', title: 'ATB_CARD_NEW_TABS_INFO_TITLE_02'},
          {tab: 'how-to', title: 'ATB_CARD_NEW_TABS_INFO_TITLE_03'},
          {tab: 'calculator', title: 'ATB_CARD_NEW_TABS_INFO_TITLE_04'}];

    const handlersMap = {
      scrollToFaq: this.scrollToFrequentlyAskedQuestions,
      toggleHeroModal: this.toggleModal,
    };

    const howToBlockItems = howToBlockItemsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    const tariffsData = tariffs_data.map(item => {
      if (typeof item.label === 'object' && item.label.link && item.label.link.onClick) {
        return {
          ...item,
          label: {
            ...item.label,
            link: {
              ...item.label.link,
              onClick: handlersMap[item.label.link.onClick],
            },
          },
        };
      }

      return item;
    });

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const loyaltyProgramData = loyaltyProgramDataConfig.map(item => ({
      ...item,
      ...(item.img1 ? { img1: imagesMap[item.img1] } : {}),
      ...(item.img2 ? { img2: imagesMap[item.img2] } : {})
    }));

    const questionWidget = this.widgetsHelper.getWidget.call(this, 'questions');
    
    return (
        <div className="atb-new">
          <Hero
            data={heroData}
            img={hero_img}
            page={page}
          />
          <div className="content">
            {!this.state.faqTab ? (
              <>
                <AdvantagesAdmin
                  data={this.widgetsHelper.getWidget.call(this, 'green_text_block')}
                  loader={this.state.loader}
                />
                <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page}>
                  <Tariffs
                    items={tariffsData}
                    title={'ATB_CARD_NEW_CARDS_TARIFFS_TITLE'}
                    btnLink={atbCardTerms}
                    btnText={'ATB_CARD_NEW_CARDS_TARIFFS_BTN'}
                    page={page}
                  />
                  <HowToBlockNew
                    title={'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TITLE'}
                    items={howToGetCardItems}
                  />
                  <QuestionsNew
                    title={'ATB_CARD_NEW_LOYALTY_PROGRAM_TITLE'}
                    subtitle={'ATB_CARD_NEW_LOYALTY_PROGRAM_SUBTITLE'}
                    items={loyaltyProgramData}
                    disableScrollTarget={true}
                  />
                  <HowToBlockNew
                    title={'ATB_CARD_NEW_HOW_TO_TITLE'}
                    subtitle={'ATB_CARD_NEW_HOW_TO_SUBTITLE'}
                    items={howToBlockItems}
                  />
                  {model.creditSum ? (
                    <CalculatorNew model={model} type="credit_cards" {...this.props}/>
                  ) : (canUseDOM ? <Preloader /> : null)}
                </Tabs>
                <AdditionalProduct
                  items={additionalCards}
                  title={'ATB_CARD_NEW_ADDITIONAL_PRODUCT_TITLE'}
                  page={page}
                />
                <QuestionsAdminNew
                  title={'ATB_CARD_NEW_FAQ_STORYBOOK_TITLE'}
                  widget={questionWidget}
                  toggleFaqTab={this.toggleFaqTab}
                  page={page}
                />
                <FilesForDownloadNew
                  lang={this.props.lang}
                  widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
                />
                <TextAboveFooterNew
                  widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
                />
              </>
            ) : (
              <FAQStorybook
                widget={questionWidget}
                title={this.l10n('ATB_CARD_NEW_FAQ_STORYBOOK_TITLE')}
                btnText={this.l10n('ATB_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
                onBtnClick={this.toggleFaqTab}
                filterByEnvironment={filterByEnvironment}
              />
            )}
          </div>
          {this.state.showModal ? 
            <CardOrderModal closeModal={this.toggleModal} product={"atb"} isOpen={this.state.showModal}/> : ''
          }
        </div>
    );
}
